import React from "react";
// @ts-ignore
import { useAppLogic } from "./hooks/useAppLogic";
// @ts-ignore
import { auth } from "./services/firebase";
// @ts-ignore
import { UserProvider } from "./context/user";
// @ts-ignore
import { DataProvider } from "./context/data";
import Splash from "./components/Splash";
import Login from "./components/Login";
import Onboarding from "./components/Onboarding";
import Home from "./components/Home";

export default function App() {
  // Firestore logic lives in useAppLogic
  const {
    appState,
    setAppState,
    userData,
    setUserData,
    events,
    communities,
    matches,
    loading,
    handleCreateEvent,
    handleCreateCommunity,
    handleAddMatch,
    handleToggleJoinEvent,
    handleCompleteSetup,
    handleLogout,
  } = useAppLogic();

  // --- CONDITIONAL SCREEN RENDERING ---
  if (appState === "splash") return <Splash onFinish={() => {}} />;

  if (appState === "auth")
    return (
      <Login
        onLoginSuccess={() => {
          // No-op: the onAuthStateChanged effect in useAppLogic handles the
          // session and moves appState forward once Firebase resolves it.
        }}
      />
    );

  // userData/setUserData come from UserContext, and events/communities/
  // matches from DataContext, instead of being passed down as props through
  // every screen — see src/context/UserContext.jsx and
  // src/context/DataContext.jsx.
  return (
    <UserProvider userData={userData} setUserData={setUserData}>
      <DataProvider events={events} communities={communities} matches={matches}>
        {appState === "onboarding" ? (
          <Onboarding
            onComplete={handleCompleteSetup}
            onBackToLogin={() => {
              auth.signOut();
              setAppState("auth");
            }}
          />
        ) : (
          <Home
            loading={loading}
            onCreateEvent={handleCreateEvent}
            onCreateCommunity={handleCreateCommunity}
            onAddMatch={handleAddMatch}
            onToggleJoinEvent={handleToggleJoinEvent}
            onLogout={handleLogout}
          />
        )}
      </DataProvider>
    </UserProvider>
  );
}
